import { render, staticRenderFns } from "./VcardDetailModal.vue?vue&type=template&id=11eebe82&scoped=true"
import script from "./VcardDetailModal.vue?vue&type=script&lang=js"
export * from "./VcardDetailModal.vue?vue&type=script&lang=js"
import style0 from "./VcardDetailModal.vue?vue&type=style&index=0&id=11eebe82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eebe82",
  null
  
)

export default component.exports